import { render, staticRenderFns } from "./MpSpeechBubble.vue?vue&type=template&id=84b1b4f6&scoped=true&"
import script from "./MpSpeechBubble.vue?vue&type=script&lang=js&"
export * from "./MpSpeechBubble.vue?vue&type=script&lang=js&"
import style0 from "./MpSpeechBubble.vue?vue&type=style&index=0&id=84b1b4f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b1b4f6",
  null
  
)

export default component.exports